import { type Accessor, createSignal, onCleanup, onMount } from "solid-js";
import { getDeeplink, updateDeeplinkRegistry } from "~/stores/deeplink";

/**
 * @deprecated Use `useDeeplink` from global provider at `~/providers/DeeplinkProvider/context` instead.
 */
export function useDeeplink(renderContainer: Accessor<HTMLDivElement | undefined>) {
	const [initialized, setInitialized] = createSignal(false);

	const onHandleClick = (event: MouseEvent) => {
		const target = event.target as HTMLElement;

		if (!target || target.tagName !== "A") {
			return;
		}

		const element = target as HTMLAnchorElement;
		const href = element.href;
		const deeplink = getDeeplink(href);

		if (!deeplink) {
			return;
		}

		event.preventDefault();
		const params = new Map<string, string>();

		if (href !== deeplink.internal) {
			const externalParts = href.split("/").reverse();
			for (const [index, param] of deeplink.queryParams.entries()) {
				params.set(param, externalParts[index]);
			}
		}

		const url = new URL(deeplink.path);

		for (const [key, value] of params) {
			url.searchParams.set(key, value);
		}

		window.open(url, "_self");
	};

	onMount(() =>
		setTimeout(async () => {
			const container = renderContainer();

			try {
				await updateDeeplinkRegistry();
			} catch (err) {
				console.error("Failed to update deeplink registry", err);
			} finally {
				setInitialized(true);

				if (!container) {
					console.warn("Couldn't find deeplink container element. Deeplinks will not work.");
				} else {
					container.addEventListener("click", onHandleClick);
				}
			}
		}),
	);

	onCleanup(() => {
		const container = renderContainer();
		if (container) {
			container.removeEventListener("click", onHandleClick);
		}
	});

	return { initialized };
}
